
import React from 'react'
import Footer from '../Footer'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/viajarMascotas.scss'
import { Link } from "react-router-dom";

export default function ViajarConMascotas() {

    return (
    <>
    <section className='viajar-mascotas'>

                {/* HERO */}
                <div className='mascotas-hero'>

                    <div className='overlay'></div>

                    <div className='container hero-content'>

                        <div style={{ marginTop: '4rem' }}>
                            <Breadcrumbs />
                        </div>

                        {/*<span className='hero-badge'>
                            Información importante
                        </span>*/}

                        <h1>
                            Documentación para viajar con mascotas
                        </h1>

                        <p>
                            Viaja tranquilo con tus animales de compañía
                            siguiendo nuestra guía oficial de requisitos
                            y documentación.
                        </p>

                    </div>

                </div>

                {/* CONTENT */}
                <div className='container mascotas-content'>

                    {/* DOCUMENTACION */}
                    <section>

                        <div className='section-header'>
                              <h2 className='title-icon'>
                                <i class="fi fi-rs-degree-credential"></i>
                                <span>Documentación</span>
                            </h2>
                        </div>

                        <div className='documents-grid'>

                            <div className='document-card'>
                                <i className="fi fi-rs-syringe"></i>

                                <h3>
                                    Certificado de vacunación
                                </h3>

                                <p>
                                    Vigente y original. Debe incluir:
                                </p>

                                <ul>
                                    <li>Rabia</li>
                                    <li>Parvovirus</li>
                                    <li>Moquillo</li>
                                </ul>
                            </div>

                            <div className='document-card'>
                                <i className="fi fi-rs-heart"></i>

                                <h3>
                                    Certificado de salud
                                </h3>

                                <p>
                                    Expedido por veterinario con menos de
                                    6 días antes de la fecha del viaje,
                                    incluyendo desparasitación.
                                </p>
                            </div>

                            <div className='document-card'>
                                <i className="fi fi-rs-stethoscope"></i>

                                <h3>
                                    Evaluación veterinaria
                                </h3>

                                <p>
                                    Requerida para mascotas gestantes
                                    o menores de 8 semanas.
                                </p>
                            </div>

                        </div>

                    </section>

                    {/* REQUERIMIENTOS */}
                    <section className='requirements-section'>

                        <div className='requirements-content'>

                            <h2>Requerimientos</h2>

                            <div className='requirement-item'>

                                <div className='icon-box'>
                                    <i className="fi fi-rs-box"></i>
                                </div>

                                <div>
                                    <h4>Transportadora</h4>

                                    <p>
                                        Jaula resistente, ventilada y con cierre seguro.
                                        Obligatoria durante el trayecto.
                                    </p>
                                </div>

                            </div>

                            <div className='requirement-item'>

                                <div className='icon-box'>
                                    <i className="fi fi-rs-paw"></i>
                                </div>

                                <div>
                                    <h4>Collar y correa</h4>

                                    <p>
                                        Uso obligatorio durante tránsito y abordaje.
                                    </p>
                                </div>

                            </div>

                            <div className='requirement-item'>

                                <div className='icon-box'>
                                    <i className="fi fi-rs-shield-dog"></i>
                                </div>

                                <div>
                                    <h4>Bozal</h4>

                                    <p>
                                        Requerido para perros grandes
                                        o con comportamiento agresivo.
                                    </p>
                                </div>

                            </div>
                            <div className='requirement-item'>

                                <div className='icon-box'>
                                    <i className="fi fi-rs-shield-dog"></i>
                                </div>

                                <div>
                                    <h4>Capacidad en cabina pet</h4>

                                    <ul>
                                        <li>2 pequeñas o 2 medianas</li>
                                        <li>1 pequeña y 1 mediana</li>
                                        <li>1 grande (máximo)</li>
                                    </ul>
                                    <p>Restricción: No se permite 1 mascota grande con otra de cualquier tamaño.</p>
                                </div>

                            </div>

                        </div>

                        <div className='petfriendly-card'>

                            <div className='petfriendly-image'></div>

                            <div className='petfriendly-info'>

                                <h4>
                                    Área especial para mascotas
                                </h4>

                                <p>
                                    Algunas embarcaciones cuentan con
                                    zonas climatizadas y cabinas pet friendly.
                                </p>

                            </div>

                        </div>

                    </section>

                    {/* INFO EXTRA */}
                    <section className='info-box'>                        
                        <strong>Notas:</strong>
                            

                        <p>
                            Las mascotas viajan en un área especial del barco.
                            Durante la travesía podrás visitarlas acompañada(o)
                            por personal autorizado.
                        </p>

                        <p>                            
                            Las mascotas no pueden permanecer en el auto durante la carga y el trayecto, y deben estar en su transportadora en el área designada para mascotas dentro del buque. 
                        </p>

                    </section>

                    {/* TABLA */}
                    <section className='tabla-section'>

                        <div className='tabla-header'>

                            <h2>
                                Medidas recomendadas de transportadoras
                            </h2>

                            <p>
                                Tu mascota debe poder moverse
                                y acostarse cómodamente.
                            </p>

                        </div>

                        <div className='tabla-responsive'>

                            <table className='mascota-tabla'>

                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Ancho</th>
                                        <th>Largo</th>
                                        <th>Altura</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Muy chicos</td>
                                        <td>30 cm</td>
                                        <td>50 cm</td>
                                        <td>37 cm</td>
                                    </tr>

                                    <tr>
                                        <td>Chicos</td>
                                        <td>42 cm</td>
                                        <td>60 cm</td>
                                        <td>30 cm</td>
                                    </tr>

                                    <tr>
                                        <td>Medianos</td>
                                        <td>52 cm</td>
                                        <td>75 cm</td>
                                        <td>50 cm</td>
                                    </tr>

                                    <tr>
                                        <td>Grandes</td>
                                        <td>57 cm</td>
                                        <td>87 cm</td>
                                        <td>65 cm</td>
                                    </tr>

                                    <tr>
                                        <td>Muy grandes</td>
                                        <td>65 cm</td>
                                        <td>110 cm</td>
                                        <td>75 cm</td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </section>

                    {/* NOTAS */}
                    <section className='notes-grid'>

                        <div className='notes-card'>

                            <h3>
                                <i className="fi fi-rs-info"></i>
                                Notas importantes
                            </h3>

                            <ul>
                                <li>
                                    Máximo 2 mascotas por pasajero.
                                </li>

                                <li>
                                    El pasajero es responsable
                                    de alimentación y limpieza.
                                </li>

                                <li>
                                    Mascotas de servicio viajan sin costo
                                    con certificación oficial.
                                </li>
                            </ul>

                        </div>

                        <div className='prohibited-card'>

                            <h3>
                                <i className="fi fi-rs-ban"></i>
                                Restricciones
                            </h3>

                            <p>
                                Algunas especies requieren validación previa
                                o pueden estar sujetas a restricciones sanitarias.
                            </p>
                            <label>No se permiten:</label>
                            <ul>
                                <li>Aves de presa</li>
                                <li>Primates con peso superior a 20 kg</li>
                                <li>Reptiles mayores de 1m de largo</li>
                            </ul>

                        </div>

                    </section>

                    {/* RELACIONADOS */}
                    <section className='related-section'>

                        <h2>Otros documentos de interés</h2>

                        <div className='related-links'>

                            <Link to='/viajar-con-menores-de-edad'>
                                <i className="fi fi-rs-family"></i>
                                Viajar con menores
                            </Link>

                            <Link to='/viajar-con-auto'>
                                <i className="fi fi-rs-car-side"></i>
                                Documentación para automóvil
                            </Link>

                            <Link to='/viajar-con-adulto-mayor'>
                                <i className="fi fi-rs-user"></i>
                                Viajar con adulto mayor
                            </Link>

                        </div>

                    </section>

                </div>

                <Footer />
            </section>
    </>
    )
}
